export const overwriteSetSinkId = (): void => {
  // Don't call it in Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1849108#c10
  if (
    navigator.userAgent.includes('Firefox') &&
    HTMLAudioElement.prototype.setSinkId
  ) {
    HTMLAudioElement.prototype.setSinkId = async function (_deviceId) {
      return undefined;
    };
  }
};
